<template>
  <summary-count title="Activities Due" :is-loading="isLoading" :count="activities" :clickable="true" @cardClicked="gotoLink">
    <template #caption>
      <div class="tw-flex tw-items-center tw-text-xs tw-mt-2 tw-gap-1 tw-flex-nowrap">
        <span class="tw-text-red-500 tw-whitespace-nowrap">{{ activitiesPastDue.toLocaleString() }} past due</span>
        <span class="tw-text-yellow-600 tw-flex-shrink-0">&middot;</span>
        <span class="tw-text-yellow-600 tw-whitespace-nowrap">{{ activitiesDueToday.toLocaleString() }} due today</span>
      </div>
    </template>
  </summary-count>
</template>

<script>
import { mapGetters } from "vuex";
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";

export default {
  name: "Activities",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
    summaryData: {
      type: Object,
      default: () => ({}),
    },
    isSummaryLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    activities() {
      return this.summaryData.activitiesDue || 0;
    },
    activitiesPastDue() {
      return this.summaryData.activitiesPastDue || 0;
    },
    activitiesDueToday() {
      return this.summaryData.activitiesDueToday || 0;
    },
    isLoading() {
      return this.isSummaryLoading;
    },
  },
  methods: {
    gotoLink() {
      if (this.isLocationFiltered) this.$router.push(`/businesses/${this.businessId}/location-todo/due-today`);
      else this.$router.push(`/businesses/${this.businessId}/business-todo/unassigned`);
    },
  },
};
</script>
